import { Component, OnInit } from '@angular/core';
import { AlertController, ModalController } from '@ionic/angular';

import { User, StateService } from '../../public-api';
import { UserFormComponent } from '../user-form/user-form.component';

@Component({
    selector: 'lib-user-overview',
    templateUrl: './user-overview.component.html',
    styleUrls: ['./user-overview.component.scss'],
    standalone: false
})
export class UserOverviewComponent implements OnInit {
  selectedUser: User;

  public deleteButtons = [
    {
      text: 'Okay',
      role: 'true',
    },
  ];
  public isDeleteAlertOpen: boolean = false;

  constructor(
    public state: StateService,

    private alertController: AlertController,
    private modalController: ModalController
  ) {}

  ngOnInit() {
    //this.state.loadUsers();
  }

  openDeleteUserAlert(user: User) {
    this.selectedUser = user;
    this.setDeleteOpen(true);
  }

  setDeleteResult(ev: any) {
    this.setDeleteOpen(false);
    if (ev.detail.role != 'true') return;
    //this.state.deleteUser(this.selectedUser.userName);
  }

  setDeleteOpen(isOpen: boolean) {
    this.isDeleteAlertOpen = isOpen;
  }

  async editUser(user: User) {
    if (user.isDeleted) return;
    const modal = await this.modalController.create({
      component: UserFormComponent,
      componentProps: {
        userToEdit: user,
      },
    });
    await modal.present();
  }
}
